import { CONFIG } from "../config.js";
import { validateFunnelEntry } from "../metrics.ts";
import { todayISO } from "../dates.ts";
import { toast } from "../toast.ts";
import { Modal, NumField, PositionSelect } from "./Modal.tsx";
import type { EntryApi, FunnelKey, Row } from "../domain.ts";

const FUNNEL_FIELDS: [FunnelKey, string][] = [
  ["contacted", "Contacted"], ["responses", "Responses"],
  ["applications", "Applications"], ["interviews", "Interviews"],
  ["offers", "Offers"], ["hires", "Hires"],
];

export type LogDailyModalProps = {
  api: EntryApi;
  isDemo: boolean;
  onClose: () => void;
  /** Nạp lại data sau khi lưu. */
  onSaved: () => Promise<void>;
};

export function LogDailyModal({ api, isDemo, onClose, onSaved }: LogDailyModalProps) {
  const today = todayISO();

  return (
    <Modal
      title="Log Daily Funnel"
      onClose={onClose}
      onSubmit={async (fd) => {
        const entry = {
          weekEnding: String(fd.get("weekEnding") ?? ""),
          position: String(fd.get("position") ?? ""),
          notes: String(fd.get("notes") ?? "").trim(),
        } as Omit<Row, "recruiter">;
        for (const [key] of FUNNEL_FIELDS) entry[key] = Number(fd.get(key));

        const err = validateFunnelEntry(entry);
        if (err) throw new Error(err);

        await api.addFunnelRow(entry);
        toast(isDemo ? "DEMO — đã thêm vào bộ nhớ (chưa lưu thật)." : "✓ Đã lưu vào SharePoint.");
        await onSaved();
      }}
    >
      <div className="f-row">
        <label className="f-field">
          <span>Date</span>
          <input type="date" name="weekEnding" defaultValue={today} max={today} required />
        </label>
        <PositionSelect positions={CONFIG.positions} />
      </div>
      <div className="f-grid">
        {FUNNEL_FIELDS.map(([name, label]) => <NumField key={name} name={name} label={label} />)}
      </div>
      <label className="f-field">
        <span>Notes (hiện ở Open Positions)</span>
        <input type="text" name="notes" placeholder="VD: Ready to offer 2 bạn M1..." />
      </label>
      <p className="f-hint">
        Nhập số phát sinh TRONG NGÀY cho vị trí bạn phụ trách — log nhiều lần/ngày hoặc bỏ
        trống ngày không có hoạt động đều được, dashboard tự cộng dồn. Có thể chọn ngày
        trong quá khứ để bổ sung.
      </p>
    </Modal>
  );
}
